const filterWidgetData = data =>
  data.widgets.map(widget => ({
    ...widget,
    masterObjectId: widget.masterObjectId || data.masterObjectId,
    masterObjectName: widget.masterObjectName || data.masterObjectName,
    masterObjectType: widget.masterObjectType || data.masterObjectType,
    masterObjectTypeId: widget.masterObjectTypeId || data.masterObjectTypeId,
    dateRangeTypeId: widget.dateRangeTypeId || data.dateRangeTypeId,
    benchmarks: widget.benchmarks.length > 0 ? widget.benchmarks : data.benchmarks,
    startDate: widget.startDate || data.startDate,
    endDate: widget.endDate || data.endDate,
    timeSeriesSetId: widget.timeSeriesSetId
  }));

const getDashboardData = data => ({
  isCanned: data.isCanned,
  masterObjectId: data.masterObjectId,
  masterObjectName: data.masterObjectName,
  masterObjectType: data.masterObjectType,
  masterObjectTypeId: data.masterObjectTypeId,
  dateRangeTypeId: data.dateRangeTypeId,
  objectTypeDetail: data.objectTypeDetail,
  objectTypeDetailId: data.objectTypeDetailId,
  benchmarks: data.benchmarks,
  startDate: data.startDate,
  endDate: data.endDate,
  id: data.id,
  dateRangeType: data.dateRangeType,
  description: data.description,
  name: data.name,
  layout: data.layout,
  timeSeriesSetId: data.timeSeriesSetId
});

const updateSingleWidget = (widgets, payload) => {
  const { id, data } = payload;

  return widgets.map(widget => (widget.id === id ? { ...widget, ...data } : widget));
};

const findBenchmarkAndUpdate = (updatedBenchmark, data) => {
  const { benchmarks } = data;
  const indexOfBenchmark = benchmarks.findIndex(item => item.id === updatedBenchmark.id);

  const updatedItems = [...benchmarks];
  updatedItems[indexOfBenchmark] = updatedBenchmark;

  return { ...data, benchmarks: updatedItems };
};

const findFirstHiddenBenchmarkAndShowIt = data => {
  const { benchmarks } = data;
  const indexOfHiddenBenchmark = benchmarks.findIndex(item => item.isVisible === false);
  const updatedBenchmarks = [...benchmarks];

  updatedBenchmarks[indexOfHiddenBenchmark] = {
    ...updatedBenchmarks[indexOfHiddenBenchmark],
    isVisible: true
  };

  return { ...data, benchmarks: updatedBenchmarks };
};

const deleteWidget = (widgets, id) => {
  const updatedWidgets = widgets.filter(widget => widget.id !== id);
  return updatedWidgets;
};

export const initialState = {
  widgets: null,
  dashboardData: {},
  createDashboardData: {}
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'DASHBOARD_READY':
      return {
        widgets: filterWidgetData(action.payload),
        dashboardData: getDashboardData(action.payload)
      };
    case 'RESET_CREATE_DATA': {
      return {
        ...state,
        createDashboardData: {}
      };
    }
    case 'UPDATED_DASHBOARD':
      return {
        ...state,
        dashboardData: { ...state.dashboardData, ...action.payload },
        createDashboardData: { ...state.createDashboardData, ...action.payload }
      };
    case 'UPDATE_WIDGET':
      return {
        ...state,
        widgets: updateSingleWidget(state.widgets, action.payload)
      };
    case 'ADD_WIDGET':
      return {
        ...state,
        widgets: [...state.widgets, { ...action.payload }]
      };
    case 'DELETE_WIDGET':
      return {
        ...state,
        widgets: deleteWidget(state.widgets, action.payload)
      };
    case 'UPDATE_BENCHMARK':
      return {
        ...state,
        dashboardData: findBenchmarkAndUpdate(action.payload, state.dashboardData),
        createDashboardData: findBenchmarkAndUpdate(action.payload, state.dashboardData)
      };
    case 'UPDATE_BENCHMARK_VISIBILITY':
      return {
        ...state,
        dashboardData: findFirstHiddenBenchmarkAndShowIt(state.dashboardData),
        createDashboardData: findFirstHiddenBenchmarkAndShowIt(state.dashboardData)
      };

    default:
      return state;
  }
};
